import axios from 'axios';
import { message, notification } from 'antd';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true,
});

const AUTH_KEYS = [
    'user_id', 'first_name', 'last_name',
    'hm_profile_id', 'hm_profile_db_id', 'hm_first_name',
];

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
                AUTH_KEYS.forEach((key) => localStorage.removeItem(key));
                notification.warning({
                    message: 'Session Expired',
                    description: 'Your session has expired. Please login again.',
                });
                setTimeout(() => {
                    window.location.href = '/login';
                }, 1500);
        } else if (error.response?.status === 429) {
            message.warning(
                error.response.data?.message || 'Too many requests. Please slow down.'
            );
        } else if (error.response?.status === 403 && error.response.data?.message?.includes('flagged')) {
            message.error(
                error.response.data.message,
                6
            );
        }
        return Promise.reject(error);
    }
);

export default api;
